import {
  useDeletePost,
  usePostPutPost,
} from '../../../services/redux/api/postsApi';
import { useState } from 'react';
import { useFileList } from '../../../hooks/use-file-list';
import { IPost } from '../../../types/interfaces/post';
import { useLayout } from '../../../context/LayoutContext';
import { INewFile } from '../../../types/interfaces/new-file';

export function usePosts(
  newPostBinding?: { communityId: string } | { pageUserId: string },
) {
  const [deletePost] = useDeletePost();
  const [postPutPost] = usePostPutPost();

  const [newPost, setNewPost] = useState<IPost>({ content: '' });
  const { showLoader, hideLoader } = useLayout();

  const {
    filesToUpload: newPostFilesToUpload,
    onDeleteFile: onDeleteNewPostFile,
    onUploadFiles: onUploadNewPostFiles,
    resetFilesState: resetNewPostFilesState,
  } = useFileList([]);

  function onEditPost(value: { content?: string; parentId?: string }) {
    setNewPost((prev) => ({ ...prev, ...value }));
  }

  function onPostDelete(postId) {
    const loaderId = showLoader();

    return deletePost({ id: postId })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        hideLoader(loaderId);
      });
  }

  function onSavePost(repliedPost?: IPost) {
    let postToSave;
    let filesToUpload;

    if (repliedPost) {
      postToSave = repliedPost;
      filesToUpload = [];
    } else {
      if ((!newPost.content && !newPostFilesToUpload.length) || !newPostBinding)
        return;

      postToSave = { ...newPostBinding, ...newPost };
      filesToUpload = newPostFilesToUpload;
    }
    const loaderId = showLoader();

    return postPutPost({
      body: {
        post: postToSave,
        filesToUpload,
      },
      id: postToSave.id,
    })
      .then(() => {
        setNewPost({ content: '' });
        resetNewPostFilesState();
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        hideLoader(loaderId);
      });
  }

  return {
    onPostDelete,
    onSavePost,
    onEditPost,
    onDeleteNewPostFile,
    onUploadNewPostFiles,
    newPost,
    newPostFilesToUpload,
  };
}
